import {memo} from 'react'

import SelectBuildRunnerListItem from './SelectBuildRunners.listItem'
import type {RunnerType} from './SelectBuildRunners.types'

import styles from './SelectBuildRunners.css'

type SelectBuildRunnersGroupProps = {
  grid?: boolean
  focusedRunner?: RunnerType
  items: Array<RunnerType>
  onLoadingComplete: () => void
  onSelect: () => void
}

function SelectBuildRunnersGroup({
  onSelect,
  items,
  focusedRunner,
  onLoadingComplete,
}: SelectBuildRunnersGroupProps) {
  const isNoFound = !items.length

  if (isNoFound) {
    return <div className={styles.notFound}>{'No runners found'}</div>
  }

  return (
    <div className={styles.listWrap}>
      <table className={styles.list}>
        <tbody>
          {items.map(runner => (
            <SelectBuildRunnerListItem
              key={runner.key}
              isFocused={runner.key === focusedRunner?.key}
              runner={runner}
              onSelect={onSelect}
              onLoadingComplete={onLoadingComplete}
            />
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default memo(SelectBuildRunnersGroup)
